
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4aNgmU5PC32NcVEoA30XFbwn1CEIahdOJW6BWVKx49QMeta } from "/vercel/path0/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93ldMH8yK_45GkokqUjh90prbfDuTYRkAHYGSM4hL3nUyT0Meta } from "/vercel/path0/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/[...slug].vue?macro=true";
import { default as sidebarnL0RwrzOVWykYmT3RQXaLS_45M8ky9QR1UZm5l8nOGrLcMeta } from "/vercel/path0/docs/pages/blocks-renderer/sidebar.vue?macro=true";
import { default as collapsible_45nested_45sidebarF5_dgLn_45315KgTkrbvTzo1BpL1h_45azyDS_dwMOrc_45VkMeta } from "/vercel/path0/docs/pages/blocks-renderer/collapsible-nested-sidebar.vue?macro=true";
import { default as blocks_45rendererq8nZYoXnUSBPhr1CMS6RRPU4Zb0Qtojwh7NlFNPCHSMMeta } from "/vercel/path0/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/blocks-renderer.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/[...slug].vue")
  },
  {
    name: "blocks-renderer",
    path: "/blocks-renderer",
    meta: blocks_45rendererq8nZYoXnUSBPhr1CMS6RRPU4Zb0Qtojwh7NlFNPCHSMMeta || {},
    component: () => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/pages/blocks-renderer.vue"),
    children: [
  {
    name: "blocks-renderer-sidebar",
    path: "sidebar",
    meta: sidebarnL0RwrzOVWykYmT3RQXaLS_45M8ky9QR1UZm5l8nOGrLcMeta || {},
    component: () => import("/vercel/path0/docs/pages/blocks-renderer/sidebar.vue")
  },
  {
    name: "blocks-renderer-collapsible-nested-sidebar",
    path: "collapsible-nested-sidebar",
    component: () => import("/vercel/path0/docs/pages/blocks-renderer/collapsible-nested-sidebar.vue")
  }
]
  }
]